import { render, staticRenderFns } from "./ServicePrice.vue?vue&type=template&id=745224e6"
import script from "./ServicePrice.vue?vue&type=script&lang=js"
export * from "./ServicePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports